// room
<template>
  <div class="link-views white-bg">
    <div class="select-div">
      <div class="mr">
        <span>选择楼栋：</span>
        <i-select v-model="BuildId" style="width:200px">
          <i-option
            v-for="item in BuildList"
            :value="item.BuildId"
            :key="item.BuildId"
          >{{ item.BuildName }}</i-option>
        </i-select>
      </div>
      <div class="mr">
        <span>选择楼层：</span>
        <i-select v-model="FloorId" style="width:200px">
          <i-option
            v-for="item in FloorList"
            :value="item.FloorId"
            :key="item.FloorId"
          >{{ item.FloorName }}</i-option>
        </i-select>
      </div>
      <div>
        <Button type="primary" class="mr" icon="md-search" @click="sureSearch(BuildId,FloorId)">查询</Button>
        <Button type="primary" icon="md-refresh" @click="sureSearch(0,0)">重置</Button>
      </div>
    </div>
    <div class="list">
      <Row :gutter="16" v-if="RoomList.Result.length>0">
        <i-col
          :xs="12"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="6"
          :xxl="4"
          v-for="(item,index) in RoomList.Result"
          :key="index"
          class="listItem"
        >
          <Card>
            <div style="text-align:center;">
              <div class="imgBox">
                <router-link :to="{name:'onlineDetails',params:{id:item.RoomId}}">
                  <img :src="port+item.ImgUrl">
                </router-link>
              </div>
              <div class="cardText text-center">
                <Tooltip :content="item.RoomName" placement="top">
                  <div class="text-overflow">{{item.RoomName}}</div>
                </Tooltip>
              </div>
            </div>
          </Card>
        </i-col>
      </Row>
      <div v-else class="nodata">暂无数据</div>
    </div>
    <div class="page-div">
      <Page
        show-total
        :total="RoomList.records"
        :current="page"
        :page-size="size"
        @on-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
import * as publicApi from "../../../api/public-api.js";
import * as allFn from "../../../utils/index.js";
export default {
  name: "online",
  data() {
    return {
      port: homeConst.baseUrl + "/", //baseurl
      loading: true,
      BuildList: [],
      FloorList: [],
      RoomList: {
        Result: []
      },
      BuildId: 0,
      FloorId: 0,
      page: 1,
      size: 12
    };
  },
  mounted() {
    this.getBuildList();
    this.getpageArr();
  },
  watch: {
    BuildId(val) {
      this.getFloorArrById(val, "FloorList");
    }
  },
  methods: {
    // 获取分页数据
    async getpageArr() {
      this.RoomList = await publicApi.GetRoomList({
        BuildId: this.BuildId ? this.BuildId : 0,
        FloorId: this.FloorId ? this.FloorId : 0,
        page: this.page ? this.page : 1,
        size: this.size ? this.size : 12
      });
      this.loading = false;
    },
    // 获取楼栋数据
    async getBuildList() {
      this.BuildList = await publicApi.GetAllBuild();
    },
    // 获取设备列表
    async getEquipmentList(RoomId) {
      this.EquipmentList = await homeApi.GetEquipmentByRoomId({
        RoomId: RoomId
      });
    },
    // 根据楼栋获取楼层
    getFloorArrById(val, item) {
      if (val > 0) {
        publicApi
          .GetFloorArr({
            BuildId: val
          })
          .then(res => {
            this[item] = res;
          });
      }
    },
    // 搜索
    sureSearch(BuildId, FloorId) {
      this.BuildId = BuildId;
      this.FloorId = FloorId;
      this.page = 1;
      this.getpageArr();
    },
    //分页
    changePage(page) {
      // this.BuildId = 0;
      // this.FloorId = 0;
      this.page = page;
      this.getpageArr();
    },
    showItem(item) {
      sessionStorage.setItem("RoomId", item.RoomId);
      this.$router.push({
        name: `onlineDetails`,
        params: {
          RoomId: item.RoomId
        }
      });
    }
  }
};
</script>

<style scoped>
</style>